export default "__VITE_ASSET__BSZsmcB2__"